import { render } from "./recycle.vue?vue&type=template&id=7d50f0dc&scoped=true"
import script from "./recycle.vue?vue&type=script&lang=js"
export * from "./recycle.vue?vue&type=script&lang=js"

import "./recycle.vue?vue&type=style&index=0&id=7d50f0dc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7d50f0dc"

export default script